/**
 * Zufallsgeneratoren fuer neue Identitaeten. Laufen ausschliesslich im Browser
 * (WebCrypto) - nichts davon verlaesst den Client unverschluesselt.
 *
 * Benutzernamen sind bewusst neutrale englische Wortpaare mit Zahl, damit sie
 * keinen Rueckschluss auf die Person zulassen und nicht wiedererkennbar sind.
 */

const KLEINBUCHSTABEN = 'abcdefghijklmnopqrstuvwxyz';
const GROSSBUCHSTABEN = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const ZIFFERN = '0123456789';
const SYMBOLE = '!$%&*+-=?@#_';

const ADJEKTIVE = [
  'quiet', 'rapid', 'amber', 'bright', 'calm', 'clever', 'crisp', 'dusty',
  'eager', 'fancy', 'gentle', 'happy', 'icy', 'jolly', 'keen', 'lively',
  'mellow', 'noble', 'odd', 'polar', 'quirky', 'rusty', 'silent', 'tidy',
  'urban', 'vivid', 'witty', 'young', 'zesty', 'bold', 'cosmic', 'dizzy',
  'early', 'foggy', 'grand', 'hidden', 'ivory', 'lunar', 'misty', 'nimble',
];

const SUBSTANTIVE = [
  'falcon', 'otter', 'maple', 'river', 'stone', 'cloud', 'ember', 'fox',
  'harbor', 'island', 'jaguar', 'kestrel', 'lantern', 'meadow', 'nebula', 'orbit',
  'panda', 'quartz', 'raven', 'summit', 'tiger', 'umbra', 'valley', 'walnut',
  'yonder', 'zephyr', 'badger', 'canyon', 'delta', 'echo', 'garnet', 'heron',
  'ibis', 'juniper', 'koala', 'lagoon', 'mango', 'needle', 'osprey', 'pine',
];

/** Kryptographisch sicherer Zufallsindex in [0, max) ohne Modulo-Verzerrung. */
const zufallsIndex = (max) => {
  const grenze = Math.floor(4294967296 / max) * max;
  const puffer = new Uint32Array(1);
  let wert;
  do {
    crypto.getRandomValues(puffer);
    wert = puffer[0];
  } while (wert >= grenze);
  return wert % max;
};

/** Fisher-Yates-Mischung mit Krypto-Zufall. */
const mische = (liste) => {
  for (let i = liste.length - 1; i > 0; i -= 1) {
    const j = zufallsIndex(i + 1);
    [liste[i], liste[j]] = [liste[j], liste[i]];
  }
  return liste;
};

/** Erzeugt ein zufaelliges Passwort; enthaelt garantiert jede aktive Zeichenklasse. */
export function erzeugePasswort(laenge = 20, mitSymbolen = true) {
  const klassen = [KLEINBUCHSTABEN, GROSSBUCHSTABEN, ZIFFERN];
  if (mitSymbolen) klassen.push(SYMBOLE);
  const pool = klassen.join('');
  const zeichen = klassen.map((klasse) => klasse[zufallsIndex(klasse.length)]);
  while (zeichen.length < laenge) zeichen.push(pool[zufallsIndex(pool.length)]);
  return mische(zeichen).join('');
}

/** Erzeugt einen neutralen, nicht wiedererkennbaren Benutzernamen (z.B. "quietfalcon42"). */
export function erzeugeBenutzername() {
  const adjektiv = ADJEKTIVE[zufallsIndex(ADJEKTIVE.length)];
  const substantiv = SUBSTANTIVE[zufallsIndex(SUBSTANTIVE.length)];
  return `${adjektiv}${substantiv}${10 + zufallsIndex(90)}`;
}
